/* import __COLOCATED_TEMPLATE__ from './unified-list-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();